import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { sec } from "../../../security";

const apiServerUrl = process.env.REACT_APP_HAISTACK_API_URL;

export const honorApi = createApi({
  reducerPath: "honor",
  tagTypes: ["Honors"],
  baseQuery: fetchBaseQuery({
    baseUrl: apiServerUrl,
    prepareHeaders: async (headers) => {
      const token = await sec.getAccessTokenSilently()();

      if (token) {
        headers.set("authorization", `Bearer ${token}`);
      }

      return headers;
    }
  }),
  endpoints: (builder) => ({
    getHonors: builder.query({
      query: () => "api/v2/honors",
      transformResponse: (response: any) => {
        return response.honors;
      }
    })
  })
});

export const { useGetHonorsQuery } = honorApi;
